<template>
  <div class="main-page f-2" ref="tableContainer">
    <v-table
      v-if="adaptHeight"
      is-horizontal-resize
      is-vertical-resize
      column-width-drag
      style="width:100%"
      :height="adaptHeight"
      class="table-style"
      :columns="columns"
      :table-data="tableData"
      row-click-color="#edf7ff"
    ></v-table>
  </div>
</template>

<script>
const crowdMapping = {
  overall: "总体",
  male: "男",
  female: "女",
  below25: "<25",
  above25: "≥25",
  male_below25: "<25男",
  male_above25: "≥25男",
  female_below25: "<25女",
  female_above25: "≥25女",
  tier1: "一线城市",
  tier2: "二线城市",
  tier3: "三线城市",
  below30: "<30",
  above30: "≥30",
  male_below30: "<30男",
  male_above30: "≥30男",
  female_below30: "<30女",
  female_above30: "≥30女",
  layer1: "18-24",
  layer2: "25-29",
  layer3: "30-34",
  layer4: "≥35",
  student: "学生",
  non_student: "非学生",
  parent: "家长",
  non_parent: "非家长"
};
import { clone } from "lodash";

import debounceClass from "../../utils/functions";
const _debounce = new debounceClass().debounce;

export default {
  name: "primarydiv_table",
  props: {
    config: {}
  },
  components: {},
  data() {
    return {
      movieApi: this.$store.getters["movie/getMovieApi"],
      crowdMapping: crowdMapping,
      adaptHeight: undefined,
      tableData: [],
      columns: [
        {
          field: "genre",
          title: "类型",
          width: 100,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
          isFrozen: true
        },
        {
          field: "crowd",
          title: "人群",
          width: 120,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
          formatter: this.tableFormatter
        },
        {
          field: "percentage",
          title: "周期",
          width: 120,
          titleAlign: "center",
          columnAlign: "center",
          formatter: this.tableFormatter,
          isResize: true
        }
      ]
    };
  },
  computed: {
    queryParams: function() {
      let movie_id = Object.entries(this.config.movie_id).filter(item => {
        return item[0] !== "0";
      });
      if (movie_id.length > 0) {
        movie_id = movie_id[0][0];
      } else {
        movie_id = "";
      }
      return {
        movie_id: movie_id,
        crowd: Object.keys(this.config.crowd)[0],
        offset: this.config.offset.id,
        is_div_me: this.config.is_div_me
      };
    }
  },
  methods: {
    generateTableFormatData: _debounce(async function() {
      this.$emit("loadingStatus", true);
      let res = await this.movieApi.getIndicatorChartData(this.queryParams);
      if (res.code !== 200 || res.status !== true) {
        this.$emit("loadingStatus", false);
        throw new Error("查询类型感知数据错误");
        return;
      }
      //抛出接口结果给上层，用以复制数据
      this.$emit("updateData", res.data);
      //----------------------------
      this.columns[2].title = res.data.offset.name;
      this.tableData = res.data.results.map(item => {
        return {
          genre: item.category,
          crowd: this.crowdMapping[Object.keys(this.config.crowd)[0]],
          percentage: ((item.count / item.base) * 100).toFixed(1),
          base: item.base
        };
      });
      this.$emit("loadingStatus", false);
    }, 500),
    tableFormatter(rowData, rowIndex, pagingIndex, field) {
      if (field === "crowd") {
        let base = rowData.base ? rowData.base : "--";
        let data = rowData[field] + `(${base || "--"})`;
        return base !== "--" && base < 50
          ? "<span>" +
              rowData[field] +
              '(<span style="color:red;">' +
              base +
              "</span>)</span>"
          : data;
      } else {
        let data =
          rowData.percentage === "--"
            ? rowData.percentage
            : rowData.percentage + `%`;
        return data;
      }
    }
  },
  watch: {
    config: {
      handler: function(to, from) {
        this.generateTableFormatData();
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.adaptHeight = this.$refs.tableContainer.offsetHeight;
    this.generateTableFormatData();
  }
};
</script>

<style lang="scss" scoped>
.main-page {
  height: 100%;
  width: 100%;
  // overflow-x: scroll;
  // overflow-y: scroll;
}
.table-style {
  height: 100%;
}
</style>